const PricingStencils = () => {
    return (
        <>
            <div className="edu-pricing-area edu-section-gap bg-image mb--20">
                <div className="container">
                        <div className="row g-5 mt--20 justify-content-center">
                            <div className={`pricing-table border border-1`}>
                                <div className="pricing-header mb-3">
                                    {/* title */}
                                    <h5 className="placeholder-glow">
                                        <span className="placeholder w-100 mb-2 "></span>
                                    </h5>
                                    {/* price & price type */}
                                    <ul className="list-unstyled d-flex justify-content-center gap-2 w-100">
                                        <li className="flex-fill">
                                            <span className="placeholder d-block w-100 price-label-height" ></span>
                                        </li>
                                        <li className="flex-fill">
                                            <span className="placeholder d-block w-100 price-label-height"></span>
                                        </li>
                                        <li className="flex-fill">
                                            <span className="placeholder d-block w-100 price-label-height"></span>
                                        </li>
                                    </ul>
                                </div>
                                {/* features */}
                                <p class="placeholder-glow gap-3 w-100 mx-auto text-center">
                                    <span class="placeholder col-12"></span>
                                    <span class="placeholder col-12"></span>
                                    <span class="placeholder col-12"></span>
                                    <span class="placeholder col-12"></span>
                                    <span class="placeholder col-12"></span>
                                </p>
                                {/* choose this path button */}
                                <div className="read-more-btn placeholder-glow w-100 w-md-auto d-flex justify-content-center justify-content-md-center mt-md-0 mt-3 ms-md-0 ms-auto">
                                    <div className="placeholder btn-placeholder" ></div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </>
    )
}

export default PricingStencils; 